import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class LotacaoService extends CRUDService{
    constructor() {
        super("lotacao");
    }

    list(){
        return http.get("/lotacao");
    }

    listBUAtivas(){
        return http.get("/lotacao/BUAtivas");
    }
    //RHFPP-1548 - Consulta Custo Mot
    listAtivas(){
        return http.get("/lotacao/ativas");
    }
}